import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

const options = [
  { value: 'default', label: 'Ordenar por defecto' },
  { value: 'price_popular', label: 'Ordenar por popularidad' },
  { value: 'price_desc', label: 'Ordenar por precio: de menor a mayor' },
  { value: 'price_asc', label: 'Ordenar por precio: de mayor a menor' }
];

const CustomSelect = ({ onChange }) => {
  const [fontSize, setFontSize] = useState('12px');
  // const [dropdownFontSize, setDropdownFontSize] = useState('12px');
  // const [shouldWrapText, setShouldWrapText] = useState(false);
  const [menuWidth, setMenuWidth] = useState('200px');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 500) {
        setFontSize('12px')
        setMenuWidth('180px')
      } else if (window.innerWidth >= 500 && window.innerWidth <= 1024) {
        setFontSize('14px')
        setMenuWidth('220px')
      } else {
        setFontSize('16px')
        setMenuWidth('250px')
      }
      // setDropdownFontSize(window.innerWidth >= 1440 ? '18px' : '16px');
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, []);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      display: 'flex',
      // padding: '0 6px',
      // whiteSpace: 'nowrap',
      color: '#000',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      '&:hover': {
        borderColor: 'transparent',
      },
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: 'none',
      height: '100%',
      cursor: 'pointer',
      // whiteSpace: shouldWrapText ? 'normal' : 'nowrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      whiteSpace: 'normal',
      maxWidth: menuWidth,
      padding:'0',
      // maxWidth: shouldWrapText ? '180px' : 'none',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '100%',
      color: '#000',
      marginRight: '-10px',
      padding: '0',
    }),
    menu: (provided) => ({
      ...provided,
      width: menuWidth,
      wordWrap: 'break-word',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#E7E3EE' : '#fff',
      color: '#000',
      padding: '10px',
      fontSize: fontSize,
      cursor: 'pointer',
      // whiteSpace: shouldWrapText ? 'normal' : 'nowrap',
      // wordWrap: shouldWrapText ? 'break-word' : 'normal',
      wordWrap: 'break-word',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#000',
      fontSize: fontSize,
      // whiteSpace: shouldWrapText ? 'normal' : 'nowrap',
      // wordWrap: shouldWrapText ? 'break-word' : 'normal',
      wordWrap: 'break-word',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#000',
      fontSize: '12px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transition: 'transform 0.2s ease',
      transform: state.selectProps.menuIsOpen ? 'rotate(90deg)' : 'rotate(0deg)',
      color: '#000',
      cursor: 'pointer',
    }),
  };

  const DropdownIndicator = (props) => {
    const { isOpen } = props.selectProps;

    return (
      <components.DropdownIndicator {...props}>
        <span className={`dropdown-indicator ${isOpen ? 'rotated' : ''}`} style={{ fontWeight: 300 }}>&gt;</span>
      </components.DropdownIndicator>
    );
  };

  return (
    <Select
      options={options}
      styles={customStyles}
      defaultValue={options[0]}
      isSearchable={false}
      components={{ DropdownIndicator }}
      onChange={onChange}
    />
  );
};

export default CustomSelect;